module.exports = __webpack_public_path__ + "static/media/home_pic.9f0bbb40.avif";